// Currency formatting for the marketplace embed.
//
// The marketplace API emits money as decimal DOLLARS everywhere:
// - Catalog charges: dollar STRINGS, e.g. one_time_amount: "10.00" (= $10).
// - Cart/order endpoints: dollar NUMBERS, e.g. unit_price: 10, total: 10 (= $10).
//   This is the TD-215 contract (verified live).

const CURRENCY_FORMATS: Record<string, { locale: string; code: string }> = {
  USD: { locale: "en-US", code: "USD" },
  CAD: { locale: "en-CA", code: "CAD" },
};

/**
 * Format a dollar amount to a locale currency string.
 * Returns e.g. "$19.99" for (19.99, "USD").
 */
export function formatCurrency(
  amount: number,
  currency: string = "USD",
): string {
  const fmt = CURRENCY_FORMATS[currency] ?? CURRENCY_FORMATS.USD;
  return new Intl.NumberFormat(fmt.locale, {
    style: "currency",
    currency: fmt.code,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
}
